var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.6312,
    height: 42.6312,
    rx: 21.3156,
    fill: "#FA0067"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6266 20.3156L27.6266 22.3156V24.3156H22.6266V30.3156L21.6266 31.3156L20.6266 30.3156V24.3156H15.6266V22.3156L17.6266 20.3156V13.3156H16.6266V11.3156H26.6266V13.3156H25.6266V20.3156ZM18.4766 22.3156H24.7766L23.6266 21.1656V13.3156H19.6266V21.1656L18.4766 22.3156Z",
    fill: "#FFF5F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.6c5ac48bdf9069b84e92723e50d9d253.svg";
export { ForwardRef as ReactComponent };